import PropTypes from 'prop-types';
import React, { memo, useCallback } from 'react';
import { useHistory, useParams } from 'react-router';
import { isMobile } from 'react-device-detect';

import { paths } from 'src/constants';

import { ContentContainer } from 'src/components/common';

import GroupCardBackground from '../GroupCardBackground';

import './index.scss';

const GroupCard = ({ cardBackgroundImage, collectionsPath, group }) => {
  const history = useHistory();
  const { groupKey, activityId } = useParams();

  const handleSelect = useCallback(
    (groupId) => {
      history.push(paths.build(collectionsPath, groupKey, activityId, groupId));
    },
    [activityId, collectionsPath, groupKey, history]
  );

  return (
    <ContentContainer
      className="memory-group-card-container"
      onClick={() => handleSelect(group.id)}
      variant={isMobile ? 'small' : null}
    >
      <div className={`memory-group-card-container--${group.label}`}>
        <GroupCardBackground
          className="memory-group-card__background"
          size={group.rows * group.cols}
          image={cardBackgroundImage}
        />
      </div>
    </ContentContainer>
  );
};

GroupCard.propTypes = {
  cardBackgroundImage: PropTypes.string.isRequired,
  collectionsPath: PropTypes.string.isRequired,
  group: PropTypes.shape({
    id: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
    rows: PropTypes.number.isRequired,
    cols: PropTypes.number.isRequired,
  }).isRequired,
};

export default memo(GroupCard);
